var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('polygon',{attrs:{"points":_vm.topPolygon,"fill":"#6d6d6d"}}),_c('polygon',{attrs:{"points":_vm.rightPolygon,"fill":"#6d6d6d"}}),_c('polygon',{attrs:{"points":_vm.frontPolygon,"fill":"#b0b0b0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }